<template>
  <div class="wrapper">
    <div class="container">
      <div class="section types-section">
        <h5>主体类型</h5>
        <div class="tag-list">
          <div class="tag-list-item" 
            :class="{'tag-list-item-active': item.propertyId===subjectType}" 
            v-for="(item, index) in subjectTypeList" 
            :key="index"
            @click="tagClick(item)">
              {{item.propertyName}}
          </div>
        </div>
      </div>
      <div class="section" v-if="subjectType==='CS202206101028'||subjectType==='CS202206101029'">
        <h5>营业执照上传</h5>
        <div class="upload-group">
          <VantUploadImg-License name="营业执照" :value="businessInfo.businessLicensePic" @valChange="getLicenseImg" />
        </div>
        <div class="input-group" v-if="businessInfo.businessLicensePic !== ''">
          <div class="input-row">
            <h5>名称</h5>
            <el-input v-model="businessInfo.businessLicenseName" placeholder="请输入名称" @input="shopLicenseNameInput" @change="shopLicenseNameChange" maxlength="20"></el-input>
          </div>
          <div class="input-row">
            <h5>统一社会信用代码</h5>
            <el-input v-model="businessInfo.businessLicense" placeholder="请输入统一社会信用代码" @input="shopLicenseInput" maxlength="30"></el-input>
          </div>
          <div class="input-row">
            <div class="error-msg" v-show="isVaildLicense && businessInfo.businessLicense !== ''">统一社会信用代码格式不正确</div>
            <h5>有效期</h5>
            <div class="validity-box" v-if="isMobile">
              <div class="col" style="width:12.5rem;" @click="isShowLicense = true" v-if="businessInfo.isLongLicense !== 1">
                <span class="date-time" v-if="businessInfo.businessLicenseDeadline !== ''">{{businessInfo.businessLicenseDeadline}}</span>
                <span class="date-placeholder" v-else>请选择有效期</span>
              </div>
              <div class="col col-valid-disable" v-else>
                <span class="date-time" v-if="businessInfo.businessLicenseDeadline !== ''">{{businessInfo.businessLicenseDeadline}}</span>
                <span class="date-placeholder" v-else>请选择有效期</span>
              </div>
              <el-checkbox v-model="businessInfo.isLongLicense" :true-label="1" :false-label="0" class="is-long" @change="businessInfo.businessLicenseDeadline = ''">长期</el-checkbox>
            </div>
            <div class="pc-validity-box" v-else>
              <el-date-picker class="col" style="width:6.5rem;"
                v-model="businessInfo.businessLicenseDeadline"
                type="date"
                :clearable="false"
                placeholder="请选择有效期"
                format="yyyy-MM-dd"
                :disabled="businessInfo.isLongLicense === 1 ? true : false">
              </el-date-picker>
              <el-checkbox v-model="businessInfo.isLongLicense" :true-label="1" :false-label="0" class="is-long" @change="businessInfo.businessLicenseDeadline = ''">长期</el-checkbox>
            </div>
            <VantDatetimePicker-License name="营业执照有效期" :showPopup="isShowLicense" @isShow="isShowLicense = false" @open="isShowLicense = true" @dateInput="licenseDateChange" />
          </div>
        </div>
      </div>
      <div class="section">
        <h5 v-if="subjectType==='CS202206101028'||subjectType==='CS202206101029'">法人证件上传</h5>
        <h5 v-else>证件上传
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">如为身份证，请上传国徽面照片；<br/>如为港澳台通行证，请上传人像面反面照片；<br/>如为护照，再次上传人像面照片即可。</div>
            <img src="../../assets/images/icon_doubt.png" class="icon-doubt" />
          </el-tooltip>
        </h5>
        <el-select v-model="userRealNameInfo.papersType" placeholder="请选择" class="select-card" v-if="!isMobile">
          <el-option
            v-for="item in cardTypes"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
        <div class="select-cont" @click="openCardType" v-else>
          <div class="select-cont-name" :class="papersTypeName==''?'select-cont-empty':''">{{papersTypeName!=''?papersTypeName:'请选择'}}</div>
        </div>
        <!-- 移动端-证件类型 -->
        <van-popup
          v-model="cardTypesShow"
          show="cardTypesShow"
          position="bottom"
          custom-style="height: 50%"
          @close="cardTypesShow=false"
        >
          <van-picker
            show-toolbar
            :defaultIndex="idCardTypesIndex"
            :columns="cardTypes"
            @confirm="confirmPapersType"
            @cancel="cardTypesShow=false"
          >
            <template #option="cardTypes">
              {{ cardTypes.name }}
            </template>
          </van-picker>
        </van-popup>
        <div class="upload-group">
          <VantUploadImg-Front name="上传证件头像面" :value="userRealNameInfo.idCardFrontPic" @valChange="getFrontImg" />
          <VantUploadImg-Back name="上传非头像面" :value="userRealNameInfo.idCardBackPic" @valChange="getBackImg" />
        </div>
        <div class="input-group" v-if="userRealNameInfo.idCardFrontPic !== '' && userRealNameInfo.idCardBackPic !== ''">
          <div class="row">
            <span class="label-name">姓名</span>
            <el-input v-model="userRealNameInfo.userRelname" placeholder="请输入姓名" @input="inputLagelName" maxlength="20"></el-input>
          </div>
          <div class="row">
            <span class="label-name">证件号</span>
            <el-input v-model="userRealNameInfo.userCard" placeholder="请输入证件号" @input="inputLagelIcard" maxlength="50"></el-input>
          </div>
          <div class="row">
            <span class="label-name">有效期</span>
            <div class="validity-box" v-if="isMobile">
              <div class="col" style="width:9rem;" @click="isShowIdCard = true" v-if="userRealNameInfo.isLong !== 1">
                <span class="date-time" style="width:6rem;" v-if="userRealNameInfo.termVaildity !== ''">{{userRealNameInfo.termVaildity}}</span>
                <span class="date-placeholder" v-else>请选择有效期</span>
              </div>
              <div class="col" style="width:9rem;background:#f5f5f5;border-radius:10px 0 0 10px;" v-else>
                <span class="date-time" style="width:6rem;" v-if="userRealNameInfo.termVaildity !== ''">{{userRealNameInfo.termVaildity}}</span>
                <span class="date-placeholder" v-else>请选择有效期</span>
              </div>
              <el-checkbox v-model="userRealNameInfo.isLong" :true-label="1" :false-label="0" class="is-long" @change="userRealNameInfo.termVaildity = ''">长期</el-checkbox>
            </div>
            <div class="pc-validity-box" v-else>
              <el-date-picker class="col" style="width:4.6rem;"
                v-model="userRealNameInfo.termVaildity"
                type="date"
                :clearable="false"
                placeholder="请选择有效期"
                format="yyyy-MM-dd"
                :disabled="userRealNameInfo.isLong === 1 ? true : false">
              </el-date-picker>
              <el-checkbox v-model="userRealNameInfo.isLong" :true-label="1" :false-label="0" @change="userRealNameInfo.termVaildity = ''">长期</el-checkbox>
            </div>
          </div>
          <VantDatetimePicker-IdCard name="营业执照有效期" :showPopup="isShowIdCard" @isShow="isShowIdCard = false" @open="isShowIdCard = true" @dateInput="idCardDateChange" />
        </div>
      </div>
      <!-- 公司 -->
      <div class="section" v-if="subjectType==='CS202206101028'||subjectType==='CS202206101029'">
        <h5>法人联系方式</h5>
        <div class="upload-group">
          <el-input v-model="bankInfo.bankTel" placeholder="请输入联系方式" @input="yeepayTelInput" maxlength="13"></el-input>
        </div>
        <div class="error-msg" v-if="!isVaildYeepayTel && bankInfo.bankTel">请输入正确的手机号</div>
        <!-- <h5 style="margin-top:10px;">法人手持“营业执照”图片</h5>
        <VantUploadImg-BusinessLicense name="手持营业执照" :value="businessInfo.businessLicensePicHold" @valChange="getBusinessLicenseImg" /> -->
      </div>
      <!-- 只有个体户显示 -->
      <div class="section radio-group-section" v-if="subjectType==='CS202206101029'">
        <div class="radio-group">
          <van-radio-group v-model="bankInfo.openType" direction="horizontal" @change="bankTypeChange">
            <van-radio :name="0" checked-color="#47B6C7" icon-size="1rem">对公账户</van-radio>
            <van-radio :name="1" checked-color="#47B6C7" icon-size="1rem">法人个人银行卡</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="section">
        <h5 v-if="bankInfo.openType==0||subjectType==='CS202206101028'">请上传开户许可证照片。开户名称必须与营业执照的名称保持一致。</h5>
        <h5 v-else>收款银行卡上传（注意：银行卡开户名必须和您填写的姓名一致）</h5>
        <VantUploadImg-AccountCard name="开户许可证照片" :value="bankInfo.openAccountLicenceUrl" @valChange="getAccountCardImg" v-if="subjectType==='CS202206101028' || bankInfo.openType == 0"/>
        <VantUploadImg-BankCard name="银行卡照片" :value="bankInfo.bankCardPic" @valChange="getBankCardImg" v-else />
        <div class="input-group" v-if="(subjectType==='CS202206101030'&&(bankInfo.bankIdcard!==''||bankInfo.bankCode!==''))||subjectType!=='CS202206101030'">
          <div class="row">
            <span class="label-name">开户名</span>
            <el-input v-model="bankInfo.openName" placeholder="请输入开户名" @input="bankInfo.openName = trimSpecial(bankInfo.openName)" maxlength="20"></el-input>
          </div>
          <div class="row">
            <span class="label-name">开户账号</span>
            <el-input v-model="bankInfo.bankIdcard" placeholder="请输入开户账号"  @input="bankInfo.bankIdcard = checkNumAndLetters(bankInfo.bankIdcard)" maxlength="30"></el-input>
          </div>
          <div class="row">
            <span class="label-name">开户行</span>
            <el-select class="bank-select-box" v-if="!isMobile"
              v-model="bankInfo.bankCode"
              filterable
              remote
              reserve-keyword
              no-match-text="''"
              placeholder="请输入开户行"
              :remote-method="remoteMethod"
              :loading="loading">
              <el-option
                v-for="item in bankList"
                :key="item.id"
                :label="item.propertyName"
                :value="item.propertyKey">
              </el-option>
            </el-select>
            <!-- <el-select v-model="bankInfo.bankCode" filterable placeholder="请选择开户行" class="bank-select-box">
              <el-option 
                v-for="item in bankList"
                :key="item.id"
                :label="item.propertyName"
                :value="item.propertyKey">
              </el-option>
            </el-select> -->
            <div class="select-cont" style="margin-bottom: 0;" @click="openBankCardType" v-else>
              <div class="select-cont-name" :class="bankCardName==''?'select-cont-empty':''">{{bankCardName!=''?bankCardName:'请选择'}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 移动端-银行卡类型 -->
      <van-popup v-model="bankTypesShow" get-container="body" :lock-scroll="true" closeable close-icon="close" @close="closePopup" @click-overlay="closePopup" @click-close-icon="closePopup" position="bottom" class="popup">
        <div class="bank-modal">
          <div class="m-header">
            选择开户行
          </div>
          <div class="m-body">
            <el-input v-model="queryBankName" placeholder="请输入开户行" maxlength="30" @input="remoteMethod" class="input"></el-input>
            <ul class="infinite-list" style="overflow:auto">
              <li v-for="item,index in bankList" :key="index" class="infinite-list-item" :class="bankInfo.bankCode==item.propertyKey?'item-active':''" @click="cBank(item)">
                <div class="bank-name">{{item.propertyName }}</div>
                <span class="icon iconfont" :class="bankInfo.bankCode==item.propertyKey?'icon-agree':'icon-a-noSelected'"></span>
              </li>
            </ul>
          </div>
        </div>
      </van-popup>

      <div class="section agreement-section">
        <span class="iconfont" :class="isRead ? 'icon-agree' : 'icon-a-noSelected'" @click="toReadAgreement"></span>
        <p class="agreement-info">
          我已阅读并同意
          《<span class="licence" @click="openCprAgreement">分销合作协议</span>》
          《<span class="licence" @click="openPrivacyAgreement">隐私协议</span>》，支付收付款监管体系由易宝支付提供，查看《<span class="licence" @click="toPreviewImg">中华人民共和国支付业务许可证</span>》</p>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer" style="z-index: 999;">
      <div class="btn-group">
        <!-- <div class="btn prev-btn" @click="goBack">上一步</div> -->
        <div class="btn confim-btn" @click="onSubmit">提交</div>
        <!-- <template v-if="subjectType==='CS202206101030'">
          || !this.businessInfo.businessLicensePicHold   || !bankInfo.bankTel
          <div class="btn confim-btn disabled-btn" v-if="!userRealNameInfo.idCardFrontPic || !userRealNameInfo.idCardBackPic || !bankInfo.bankCardPic || !isRead">提交</div>
          <div class="btn confim-btn" @click="onSubmit">提交</div>
        </template>
        <template v-else>
          <div class="btn confim-btn disabled-btn" v-if="!businessInfo.businessLicensePic || !userRealNameInfo.idCardFrontPic || !userRealNameInfo.idCardBackPic || !bankInfo.bankTel || !isVaildYeepayTel ||  !isRead">提交</div>
          <div class="btn confim-btn" @click="onSubmit">提交</div>
        </template> -->
        <!-- <router-link :to="{ path: '/distribution/apply-results?shopCode=' + shopCode}" class="jump-btn">跳过</router-link> -->
      </div>
    </div>
    <ContactBtn />

    <van-popup v-model="isShowCpr" get-container="body" closeable close-icon="close" @close="closePopup" @click-overlay="closePopup" @click-close-icon="closePopup" position="bottom" class="popup">
      <div class="agreement-modal">
        <div class="m-header">
          <h3>分销合作协议</h3>
        </div>
        <div class="m-body ql-editor" v-html="cooperationAgreement"></div>
      </div>
    </van-popup>
    <van-popup v-model="isShowPrivacy" get-container="body" closeable close-icon="close" @close="closePopup" @click-overlay="closePopup" @click-close-icon="closePopup" position="bottom" class="popup">
      <div class="agreement-modal">
        <div class="m-header">
          <h3>隐私协议</h3>
        </div>
        <div class="m-body ql-editor" v-html="privacyAgreement"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import VantUploadImg from '@/components/VantUploadImg.vue';
import VantDatetimePicker from '@/components/VantDatePicker.vue';
import { validPhone, validStrAndNum } from '@/utils/validate';
import { getPropertyByPar, licenseOcrAuth, bankcardOcrAuth, idcardOcrAuth } from '@/api/auth';
import { getLoginDistributionInfo, addDistributionAuth, getAccountInfo} from '@/api/distribution/index';
import { getCategory, contract }  from '@/api/baseinfo';
// import { bankList } from '@/utils/bankList.js';
import bankJson from '@/assets/json/bankList.json';

export default {
  name: 'baseinfo-auth',
  components: {
    'VantUploadImg-License': VantUploadImg,
    'VantUploadImg-Front': VantUploadImg,
    'VantUploadImg-Back': VantUploadImg,
    'VantUploadImg-BankCard': VantUploadImg,
    'VantUploadImg-Qualifi': VantUploadImg,
    'VantUploadImg-BusinessLicense': VantUploadImg,
    'VantUploadImg-AccountCard': VantUploadImg,
    'VantDatetimePicker-License': VantDatetimePicker,
    'VantDatetimePicker-IdCard': VantDatetimePicker
  },
  data() {
    return {
      userCode: sessionStorage.getItem('userCode')||null,
      shopCode: sessionStorage.getItem('shopCode')||null,
      isMobile: false,
      isVaildLicense: false,
      isVaildYeepayTel: false,
      isRead: false,
      isShowCpr: false,
      isShowPrivacy: false,
      isShowLicense: false,
      isShowIdCard: false,
      isCredentials: null,  // 是否必传资质
      credentialsDesc: null,
      supplementImage: '',
      qualificationsUrl: '',
      cooperationAgreement:'',
      privacyAgreement:'',
      papersTypeName: '',
      bankCardName: '',
      cardTypesShow: false,
      bankTypesShow: false,
      idCardTypesIndex: null,
      cardTypes: [{name: '身份证',value: 1,key: 'ID_CARD'},{name: '护照',value: 0,key: 'PASSPORT'},{name: '港澳居民往来内地通行证',value: 2,key: 'HM_VISITORPASS'},{name: '台胞证',value: 3,key: 'TAIWAN'},{name: '士兵证',value: 4,key: 'SOLDIER'},{name: '军官证',value: 5,key: 'OFFICERS'}],
      subjectTypeList: [{propertyId:"CS202206101030",propertyName:"个人"},{propertyId:"CS202206101028",propertyName:"企业"},{propertyId:"CS202206101029",propertyName:"个体户"}],
      subjectType: '',  //CS202206101030
      userRealNameInfo: {
        "idCardBackPic": '',
        "idCardFrontPic": '',
        "isLong": 0,
        "papersType": null,
        "termVaildity": null,
        "userCard": null,
        "userRelname": null,
      },
      businessInfo: {
        "businessLicense": null,
        "businessLicenseAddress": null,
        "businessLicenseDeadline": null,
        "businessLicenseName": null,
        "businessLicensePic":'',
        "isLongLicense": 0
      },
      bankInfo: {
        "bankCardPic": '',
        "bankCode": null,
        "bankIdcard": null,
        "bankTel": sessionStorage.getItem('phone'),
        "openAccountLicenceUrl": '',
        "openName": null,
        "openType": 1,
      },
      merchantNo: null,
      isRepeat: false,
      loading: false,
      bankList: [],
      queryBankName:'',
    };
  },
  created() {
    let authInfo = JSON.parse(sessionStorage.getItem('authInfo'));
    let authInputInfo = JSON.parse(sessionStorage.getItem('authInputInfo'));
    let userRealNameInfo = JSON.parse(sessionStorage.getItem('userRealNameInfo'));
    if(authInfo) {
      // this.supplementImage = authInfo.supplementImage[0] !== '' ? authInfo.supplementImage.join(',') : '';
      this.bankInfo = {
        "bankCardPic": authInfo.bankCardPic,
        "bankCode": authInfo.bankCode,
        "bankIdcard": authInfo.bankIdcard,
        "bankTel": authInfo.bankTel,
        "openAccountLicenceUrl": authInfo.openAccountLicenceUrl,
        "openName": authInfo.openName,
        "openType": authInfo.openType,
      };
      this.isVaildYeepayTel = this.bankInfo.bankTel?validPhone(this.bankInfo.bankTel):false;
      this.bankList = bankJson.filter(item => {
        return item.propertyKey.indexOf(authInfo.bankCode) > -1;
      })||[];
      this.bankCardName = this.bankList.length>0?this.bankList[0].propertyName:'';
      this.queryBankName = this.bankCardName;
    }else{
      // this.bankList = bankJson.slice(0, 50);
    }
    if(authInputInfo) {
      this.businessInfo = {
        "businessLicense": authInputInfo.businessLicense,
        "businessLicenseAddress": authInputInfo.businessLicenseAddress,
        "businessLicenseDeadline": authInputInfo.businessLicenseDeadline,
        "businessLicenseName": authInputInfo.businessLicenseName,
        "businessLicensePic": authInputInfo.businessLicensePic,
        "isLongLicense": authInputInfo.isLongLicense,
      }
    }
    if(userRealNameInfo){
      this.userRealNameInfo = {
        "idCardBackPic": userRealNameInfo.idCardBackPic,
        "idCardFrontPic": userRealNameInfo.idCardFrontPic,
        "isLong": userRealNameInfo.isLong,
        "papersType": userRealNameInfo.papersType,
        "termVaildity": userRealNameInfo.termVaildity,
        "userCard": userRealNameInfo.userCard,
        "userRelname": userRealNameInfo.userRelname,
      }
      let papersTypeArr = this.cardTypes.filter(v=>{return v.value==userRealNameInfo.papersType})||[];
      this.papersTypeName = papersTypeArr.length>0?papersTypeArr[0].name:'';
      let cardIndex = this.cardTypes.findIndex(v=>{return v.value==userRealNameInfo.papersType});
      this.idCardTypesIndex = cardIndex!=-1?cardIndex:0;
    }
    if(this.$route.query&&this.$route.query.shopCode){
      this.shopCode = this.$route.query.shopCode;
    }
    if(this.$route.query&&this.$route.query.merchantNo){
      this.merchantNo = this.$route.query.merchantNo;
    }
    this.getPropertyByPar();
    this.getQualificationImg();
    if(this.merchantNo) {
      this.getAccountInfo();
    } else {
      this.getDistributionInfo();
    }
    this.mobileTerminal((data) => {
      this.isMobile = data
    })
  },
  methods: {
    cBank(item){
      this.bankInfo.bankCode = item.propertyKey;
      this.bankCardName = item.propertyName;
      this.bankTypesShow = false;
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.bankList = bankJson.filter(item => {
            return item.propertyName.indexOf(query) > -1;
          });
        }, 200);
      } else {
        if(this.bankInfo.bankCode){
          this.bankList = bankJson.filter(item => {
            return item.propertyKey.indexOf(this.bankInfo.bankCode) > -1;
          });
        }else{
          this.bankList = bankJson.slice(0, 50);
        }
      }
    },
    getAccountInfo() {
      getAccountInfo({"merchantNo":this.merchantNo}).then(res=>{
        let data = res.data;
        if(res.code===200&&res.data){
          this.userRealNameInfo = data.userRealNameInfo?data.userRealNameInfo:{
            "idCardBackPic": '',
            "idCardFrontPic": '',
            "isLong": 0,
            "papersType": null,
            "termVaildity": null,
            "userCard": null,
            "userRelname": null,
          };
          this.businessInfo = data.businessInfo?data.businessInfo:{
            "businessLicense": null,
            "businessLicenseAddress": null,
            "businessLicenseDeadline": null,
            "businessLicenseName": null,
            "businessLicensePic":'',
            "isLongLicense": 0
          };
          if(data.bankInfos){
            this.bankInfo = data.bankInfos&&data.bankInfos.length>0?data.bankInfos[0]:{
              "bankCardPic": '',
              "bankCode": null,
              "bankIdcard": null,
              "bankTel": sessionStorage.getItem('phone'),
              "openAccountLicenceUrl": '',
              "openName": null,
              "openType": 1,
            };
          }
          if(data.openAccount){
            this.bankInfo = data.openAccount?data.openAccount:{
              "bankCardPic": '',
              "bankCode": null,
              "bankIdcard": null,
              "bankTel": sessionStorage.getItem('phone'),
              "openAccountLicenceUrl": '',
              "openName": null,
              "openType": 1,
            }
          }
          this.isVaildYeepayTel = this.bankInfo.bankTel?validPhone(this.bankInfo.bankTel):false;
          this.subjectType = data.distributionInfo?data.distributionInfo.subjectType:null;
        }
      })
    },
    getDistributionInfo() {
      getLoginDistributionInfo({"userCode":this.userCode,"shopCode":this.shopCode}).then(res=>{
        let data = res.data;
        if(res.code===200&&res.data){
          this.userRealNameInfo = data.userRealNameInfo?data.userRealNameInfo:{
            "idCardBackPic": '',
            "idCardFrontPic": '',
            "isLong": 0,
            "papersType": null,
            "termVaildity": null,
            "userCard": null,
            "userRelname": null,
          };
          this.businessInfo = data.businessInfo?data.businessInfo:{
            "businessLicense": null,
            "businessLicenseAddress": null,
            "businessLicenseDeadline": null,
            "businessLicenseName": null,
            "businessLicensePic":'',
            "isLongLicense": 0
          };
          if(data.bankInfos){
            this.bankInfo = data.bankInfos&&data.bankInfos.length>0?data.bankInfos[0]:{
              "bankCardPic": '',
              "bankCode": null,
              "bankIdcard": null,
              "bankTel": sessionStorage.getItem('phone'),
              "openAccountLicenceUrl": '',
              "openName": null,
              "openType": 1,
            };
          }
          if(data.openAccount){
            this.bankInfo = data.openAccount?data.openAccount:{
              "bankCardPic": '',
              "bankCode": null,
              "bankIdcard": null,
              "bankTel": sessionStorage.getItem('phone'),
              "openAccountLicenceUrl": '',
              "openName": null,
              "openType": 1,
            }
          }
          this.isVaildYeepayTel = this.bankInfo.bankTel?validPhone(this.bankInfo.bankTel):false;
          this.subjectType = data.distributionInfo?data.distributionInfo.subjectType:null;
        }
      })
    },
    tagClick(data) {
      this.subjectType = data.propertyId;
      this.$forceUpdate();
    },
    bankTypeChange() {
      this.bankInfo.openName = this.subjectType==='CS202206101029'&&this.bankInfo.openType===0?this.businessInfo.businessLicenseName:null;
    },
    toPreviewImg() {
      if(!this.qualificationsUrl) return this.Toast('支付业务资质图片加载失败，请稍后再试~');
      ImagePreview({
        images: this.qualificationsUrl ? [this.qualificationsUrl] : [],
        closeable: true	
      })
    },
    getQualificationImg() {
      getCategory('CS20220610102').then(res => {
        if(res.data && res.data.length > 0) {
          this.qualificationsUrl = res.data[0].constantImg;
        }
      })
    },
    shopLicenseInput(val) {
      val = this.checkNumAndLetters(val);
      if(!validStrAndNum(val)) {
        this.isVaildLicense = true;
        this.businessInfo.businessLicense = val;
        return 
      } else {
        this.isVaildLicense = false;
        this.businessInfo.businessLicense = val.toString().toUpperCase();
      }
    },
    licenseDateChange(val) {
      this.businessInfo.businessLicenseDeadline = val;
    },
    idCardDateChange(val) {
      this.userRealNameInfo.termVaildity = val;
    },
    yeepayTelInput(value) {
      value = this.checkNumber(value);
      this.bankInfo.bankTel = value;
      this.isVaildYeepayTel = validPhone(value);
    },
    shopLicenseNameInput(val) {
      val = this.trimSpecial(val);
      this.businessInfo.businessLicenseName = val;
    },
    shopLicenseNameChange(val){
      this.bankInfo.openName = this.subjectType==='CS202206101028'||(this.subjectType==='CS202206101029'&&this.bankInfo.openType===0)?val:null;
    },
    goBack() {
      this.$router.go(-1);
    },
    toReadAgreement() {
      this.isRead = !this.isRead;
    },
    openCprAgreement() {
      if(this.cooperationAgreement){
        this.isShowCpr = true;
        document.body.style.position = 'fixed';
        document.body.style.overflow = 'auto';
      }else{
        contract('CS202206131107751').then(res => {
          if(res.data.articleJson){
            let data = res.data;
            let articleJson = JSON.parse(data.articleJson);
            this.cooperationAgreement = articleJson.AT;
            this.isShowCpr = true;
            document.body.style.position = 'fixed';
            document.body.style.overflow = 'auto';
          }
        })
      }
    },
    openPrivacyAgreement() {
      if(this.privacyAgreement){
        this.isShowPrivacy = true;
        document.body.style.position = 'fixed';
        document.body.style.overflow = 'auto';
      }else{
        contract('CS20220613110694').then(res => {
          if(res.data.articleJson){
            let data = res.data;
            let articleJson = JSON.parse(data.articleJson);
            this.privacyAgreement = articleJson.AT;
            this.isShowPrivacy = true;
            document.body.style.position = 'fixed';
            document.body.style.overflow = 'auto';
          }
        })
      }
    },
    closePopup() {
      document.body.style.position = '';
      this.isShowCpr=false;
      this.isShowPrivacy=false; 
    },
    getLicenseImg(val) {
      this.businessInfo.businessLicensePic = val;
      if(!val) return;
      if(val==='') {
        this.bankInfo.openName = this.subjectType==='CS202206101028'||(this.subjectType==='CS202206101029'&&this.bankInfo.openType===0)?'':null;
        this.businessInfo.businessLicensePic = '';
        this.inputForm = {
          shopLicense: '',
          shopLicenseName: '',
          shopLicenseDeadline: '',
          lagelVaildTime: '',
          isLongId: 0,       // 身份证
          isLongLicense: 0   // 营业执照
        }
        return false;
      }
      licenseOcrAuth(val).then(res => {
          let data = JSON.parse(res.msg)
          if(data.ENTERPRISE_ID == '') {
            this.Toast(data.ENTERPRISE_BUSINESS_CARD_OCR_STATUS)
          } else {
            let dateTime = data.ENTERPRISE_VALID_DATE_END;
            if(dateTime&&dateTime!==''&&dateTime!=='无') {
              let year = dateTime.substr(0,4);
              let month = dateTime.substr(5,2);
              let day = dateTime.substr(8,2);
              this.businessInfo.businessLicenseDeadline = year+'-'+month+'-'+day;
            }
            this.businessInfo.businessLicense = data.ENTERPRISE_ID;
            this.businessInfo.businessLicenseName = data.ENTERPRISE_NAME_CH;
            this.bankInfo.openName = this.subjectType==='CS202206101028'||(this.subjectType==='CS202206101029'&&this.bankInfo.openType===0)?data.ENTERPRISE_NAME_CH:null;
            this.$forceUpdate();
          }
      })
    },
    openCardType(){
      this.cardTypesShow=true;
    },
    confirmPapersType(data){
      this.papersTypeName = data.name;
      this.userRealNameInfo.papersType = data.value;
      let cardIndex = this.cardTypes.findIndex(v=>{return v.value==this.userRealNameInfo.papersType});
      this.idCardTypesIndex = cardIndex!=-1?cardIndex:0;
      this.cardTypesShow = false;
    },
    openBankCardType(){
      this.bankTypesShow=true;
    },
    getFrontImg(val) {
      this.userRealNameInfo.idCardFrontPic = val;
      if(!val) return;
      if(val==='') {
        this.userRealNameInfo.idCardFrontPic = '';
        return false;
      }
      this.userRealNameInfo.userRelname = '';
      this.userRealNameInfo.userCard = '';
      idcardOcrAuth({url: val, side: 'front'}).then(res => {
          let data = res.data.words_result;
          if(res.code===200) {
            this.userRealNameInfo.userRelname = data['姓名']?data['姓名'].words:'';
            this.userRealNameInfo.userCard = data['公民身份号码']?data['公民身份号码'].words:'';
            this.$forceUpdate();
          } else {
            this.Toast(res.msg)
          }
      })
    },
    getBackImg(val) {
      this.userRealNameInfo.idCardBackPic = val;
      if(!val) return;
      if(val==='') {
        this.userRealNameInfo.idCardBackPic = '';
        return false;
      }
      this.userRealNameInfo.termVaildity = '';
      idcardOcrAuth({url: val, side: 'back'}).then(res => {
          let data = res.data.words_result;
          if(res.code===200) {
            let dateTime = data['失效日期']?data['失效日期'].words:'';
            if(dateTime&&dateTime!=='') {
              let year = dateTime.substr(0,4);
              let month = dateTime.substr(4,2);
              let day = dateTime.substr(6,2);
              this.userRealNameInfo.termVaildity = year+'-'+month+'-'+day;
              this.$forceUpdate();
            }
          } else {
            this.Toast(res.msg)
          }
      })
    },
    inputLagelName(e) {
      e = this.trimSpecial(e);
      this.$set(this.userRealNameInfo, 'userRelname', e);
    },
    inputLagelIcard(e) {
      e = this.trimSpecial(e);
      this.$set(this.userRealNameInfo, 'userCard', e);
    },
    getBusinessLicenseImg(val) {
      this.businessInfo.businessLicensePicHold = val;
    },
    getQualifiImg(val) {
      this.supplementImage = val;
    },
    getBankCardImg(val) {
      this.bankInfo.bankCardPic = val;
      if(!val) return;
      if(val == '') {
        this.bankInfo.bankCardPic = '';
        return false;
      }
      if((this.subjectType==='CS202206101029'&&this.bankInfo.openType==0)||this.subjectType==='CS202206101028') return false;
      bankcardOcrAuth({url: val}).then(res => {
          let data = res.data.result;
          if(res.code===200) {
            this.bankInfo.openName = data&&data.holder_name?data.holder_name:null;
            this.bankInfo.bankIdcard = data&&data.bank_card_number?data.bank_card_number:null;
            this.bankInfo.bankCode = data&&data.property_key?data.property_key:null;
            this.bankCardName = data&&data.bank_name?data.bank_name:'';
            this.queryBankName = this.bankCardName;
            if(!this.bankInfo.bankCode){
              this.bankList = bankJson.filter(item => {
                return item.propertyName.indexOf(this.bankCardName) > -1;
              })||[];
              this.bankInfo.bankCode = this.bankList.length>0?this.bankList[0].propertyKey:'';
            }
            this.$forceUpdate();
          } else {
            this.Toast(res.msg)
          }
      })
    },
    getAccountCardImg(val) {
      this.bankInfo.openAccountLicenceUrl = val;
    },
    getPropertyByPar() {
      getPropertyByPar(this.shopCode).then(res => {
        if(res.data) {
          this.isCredentials = res.data.isCredentials;
          this.credentialsDesc = res.data.credentialsDesc;
        }
      })
    },
    onSubmit() {
      let params = {};
      this.businessInfo.businessLicenseDeadline = !this.isMobile ? this.parseTime(this.businessInfo.businessLicenseDeadline, '{y}-{m}-{d}') : this.businessInfo.businessLicenseDeadline;
      this.userRealNameInfo.termVaildity = !this.isMobile ? this.parseTime(this.userRealNameInfo.termVaildity, '{y}-{m}-{d}') : this.userRealNameInfo.termVaildity;
      if(this.subjectType==='CS202206101029') {
        this.bankInfo.openType = this.bankInfo.openType;
      } else {
        this.bankInfo.openType = this.subjectType==='CS202206101028' ? 0 : 1;
      }
      sessionStorage.setItem('authInfo', JSON.stringify(this.bankInfo));
      sessionStorage.setItem('authInputInfo', JSON.stringify(this.businessInfo));
      sessionStorage.setItem('userRealNameInfo', JSON.stringify(this.userRealNameInfo));
      if(this.subjectType==='CS202206101030') {
        if(this.userRealNameInfo.isLong != 1 && this.userRealNameInfo.termVaildity === '') return this.Toast('请完善证件有效期~');
        if(!this.userRealNameInfo.userRelname || !this.userRealNameInfo.userCard || !this.bankInfo.openName || !this.bankInfo.bankIdcard || !this.bankInfo.bankCode) {
          return this.Toast('请完善信息~');
        }
      } else {
        if(this.businessInfo.isLongLicense != 1 && this.businessInfo.businessLicenseDeadline === '') return this.Toast('请完善营业执照有效期~');
        if(this.userRealNameInfo.isLong != 1 && this.userRealNameInfo.termVaildity === '') return this.Toast('请完善证件有效期~');
        if(this.businessInfo.businessLicense == '' || this.isVaildLicense || this.businessInfo.businessLicenseName == '' || !this.userRealNameInfo.userRelname || !this.userRealNameInfo.userCard || !this.bankInfo.openName || !this.bankInfo.bankIdcard || !this.bankInfo.bankCode) {
          return this.Toast('请完善信息~');
        }
      }
      if(this.bankInfo.openType == 0 || this.subjectType==='CS202206101028') {
        this.bankInfo.bankCardPic = '';
        if(this.bankInfo.openAccountLicenceUrl == '') return this.Toast('请上传开户许可证图片');
      }
      if(this.subjectType==='CS202206101029' && this.bankInfo.openType == 1) {
        this.bankInfo.openAccountLicenceUrl = '';
        if(this.bankInfo.bankCardPic == '') return this.Toast('请上传银行卡图片');
      }
      // if(this.userRealNameInfo.userCard.length < 18) {
      //   return this.Toast('身份证号必须为18位');
      // }
      if(this.bankInfo.bankIdcard.length < 1) return this.Toast('请输入银行卡号');
      if(!this.userRealNameInfo.idCardFrontPic) return this.Toast('请上传证件头像面');  // 请上传身份证头像面
      if(!this.userRealNameInfo.idCardBackPic) return this.Toast('请上传非头像面');   // 请上传身份证国徽面
      if(this.subjectType=='CS202206101030'&&!this.bankInfo.bankCardPic) return this.Toast('请上传银行卡照片');
      if(this.subjectType!='CS202206101030'&&!this.businessInfo.businessLicensePic) return this.Toast('请上传营业执照');
      if(this.subjectType!='CS202206101030'&&!this.bankInfo.bankTel&&!this.isVaildYeepayTel) return this.Toast('请输入法人联系手机号/座机');
      if(!this.isRead) return this.Toast('请阅读并勾选协议');
      params = {
        subjectType: this.subjectType,
        bankInfo: this.bankInfo,
        businessInfo: this.businessInfo,
        userRelNameInfo: this.userRealNameInfo,
        shopCode: this.shopCode
      }
      if(this.isRepeat) return false;
      this.isRepeat = true;
      addDistributionAuth(params).then(res => {
        this.isRepeat = false;
        if(res.code == 200) {
          this.$router.push('/distribution/apply-results');
          sessionStorage.removeItem('authInfo');
          sessionStorage.removeItem('authInputInfo');
          sessionStorage.removeItem('userRealNameInfo');
          sessionStorage.removeItem('annualFee');
          sessionStorage.removeItem('scaleFormInfo');
          sessionStorage.removeItem('scaleInfo');
        } else {
          return this.Toast(res.msg);
        }
      }).catch(err=>{
        this.isRepeat = false;
      })
      // setTimeout(()=>{
      //   this.$router.push('/distribution/apply-results');
      // }, 500)
    },
  }
}
</script>

<style lang="scss" scoped>

@media screen and (max-width:750px){
  .container{
    padding-top: .05rem;
  }
  .section{
    width: 16.7rem;
    margin: 0 auto 1.4rem;
    h5{
      margin-bottom: .4rem;
      font-size: .7rem;
      color: #666;
      font-weight: 400;
      display: flex;
      align-items: center;
      .icon-doubt{
        width: .8rem;
        margin-left: .2rem;
        cursor: pointer;
      }
    }
    .select-card{
      width: 100%;
      margin: .5rem 0;
      /deep/ .el-input__inner{
        border-radius: .5rem;
        font-size: .7rem;
        color: #222;
      }
    }
    .upload-group{
      @include flex(space-between);
      /deep/ .el-input__inner, /deep/ .el-textarea__inner{
        border-radius: .5rem;
        border: .05rem solid #ddd;
        font-size: .8rem;
        color: #222;
      }
      /deep/ .el-input__inner::-webkit-input-placeholder, /deep/ .el-textarea__inner::-webkit-input-placeholder{
        font-size: .8rem;
      }
      /deep/ .el-input__inner{
        height: 2.4rem;
      }


      /deep/ .van-uploader__input-wrapper{
        width: 7.5rem;
        height: 7.5rem;
        @include flex();
        flex-direction: column;
      }
      .item{
        width: 7.5rem;
        height: 7.5rem;
        background: #F5F5F7;
        border-radius: .8rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        .icon-add{
          font-size: 1.2rem;
          color: $base-color;
        }
        .txt{
          display: inline-block;
          font-size: .7rem;
          color: #999;
          margin-top: .3rem;
        }
      }
      .img-list{
        img{
          width: 7.5rem;
          height: 7.5rem;
          border-radius: .8rem;
        }
        .img-box{
          position: relative;
          .iconfont{
            font-size: 1.4rem;
            color: #222;
            position: absolute;
            right: .1rem;
            top: .1rem;
            z-index: 2;
          }
        }
      }
    }
    .input-group{
      margin-top: .5rem;
      .input-row{
        margin-bottom: .5rem;
      }
      .row{
        height: 2rem;
        @include flex-align();
        margin-bottom: .25rem;
        .label-name{
          width: 4.4rem;
          height: 2rem;
          line-height: 2rem;
          display: inline-block;
          margin-right: .25rem;
          font-size: .75rem;
          color: #222;
          text-align: left;
        }
      }
      /deep/ input, .validity-box{
        height: 2rem;
        // margin-bottom: .25rem;
        border-radius: .5rem;
        // border-radius: .5rem 0 0 .5rem;
        // border: .05rem solid #ddd;
        font-size: .8rem;
        color: #222;
        span{
          // width: 100%;
          height: 2rem;
          line-height: 2rem;
          padding: 0 15px;
          display: inline-block;
          font-size: .8rem;
        }
        .date-time{
          width: 16rem;
          color: #222;
        }
        .date-placeholder{
          width: calc(100% - 15px);
          display: inline-block;
          color: #ccc;
          padding-right: 0;
        }
      }
      .col-valid-disable{
        width:12.5rem;height:100%;background:#f5f5f5;border-radius:.5rem 0 0 .5rem;
      }
      /deep/ .el-input__inner::-webkit-input-placeholder {
        font-size: .8rem;
        color: #ccc;
        font-weight: 400;
      }
      .validity-box, .pc-validity-box{
        width: 100%;
      }
      /deep/ .is-disabled{
      .el-input__inner{
          border: 10px 0 0 10px;
        }
      }
    }
  }
  .types-section{
    margin-top: 1.25rem;
    .tag-list{
      width: 16.7rem;
      display: flex;
      flex-wrap: wrap;
      &-item{
        width: 5.1rem;
        height: 2.2rem;
        background: #fff;
        border-radius: .5rem;
        border: .05rem solid #CFE1EA;
        font-size: .8rem;
        color: #222;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 .5rem .5rem 0;
        cursor: pointer;
        &:nth-child(3n+3){
          margin-right: 0;
        };
        &-active{
          background: $base-color;
          border: .05rem solid $base-color;
          color: #fff;
        }
      }
    }
  }
  .validity-box, .pc-validity-box{
    border: 1px solid #DCDFE6;
  }
  .pc-validity-box{
    border-radius:.5rem;
    /deep/ .el-input__inner{
      border: 0;
    }
  }
  .validity-box, .pc-validity-box{
    position: relative;
    /deep/ .el-checkbox{
      width: 4rem;
      height: 2rem;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
      color: #47B6C7;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background: #47B6C7;
      border-color: #47B6C7;
    }
  }
  .pc-validity-box{
    height: 2rem;
    /deep/ .el-checkbox__input, /deep/ .el-checkbox__inner{
      width: .8rem;
      height: .8rem;
    }
    /deep/ .el-checkbox__inner::after{
      height: 0.6rem;
      left: 0.35rem;
    }
    /deep/ .el-checkbox__label{
      line-height: 1;
      font-size: .7rem;
    }
    /deep/ .el-input__inner{
      margin-bottom: 0;
    }
  }
  .radio-group-section{
    width: 16.7rem;
    height: 3rem;
    margin-bottom: .65rem;
    .radio-group{
      height: 3rem;
      .van-radio-group{
        height: 3rem;
        .van-radio{
          font-size: .8rem;
          color: #222;
          &:first-child{
            margin-right: 1.8rem;
          }
        }
      }
    }
  }
  .bank-select-box{
    width: 16.65rem;
    height: 2rem;
    /deep/ .el-input{
      height: 2rem;
    }
    /deep/  .el-input__inner{
      height: 2rem;
      border-radius: .5rem;
      border: .05rem solid #DDDDDD;
      font-size: .8rem;
      color: #222;
    }
    /deep/ .el-input__inner::-webkit-input-placeholder {
      font-size: .8rem;
      color: #ccc;
      font-weight: 400;
    }
  }
  .supplement-section{
    .upload-item{
      /deep/ .img-box{
        margin-bottom: 1rem;
      }
    }
  }
  .agreement-section{
    padding: .6rem .8rem;
    background: #F5F5F7;
    border-radius: .8rem;
    box-sizing: border-box;
    @include flex();
    .iconfont{
      font-size: 1rem;
      cursor: pointer;
    }
    .icon-a-noSelected{
      color: #ccc;
    }
    .icon-agree{
      color: $base-color;
    }
    .agreement-info{
      line-height: 1.5;
      margin-left: .6rem;
      font-size: .7rem;
      color: #0A1629;
      cursor: pointer;
      a{
        font-size: .7rem;
        color: #0A1629;
      }
      .licence{
        font-size: .7rem;
        color: $base-color;
      }
    }
  }

  .agreement-modal{
    width: 16.7rem;
    margin: 0 auto;
    padding-top: .05rem;
    padding-bottom: .75rem;
    .m-header{
      width: 16.7rem;
      margin: 0 auto;
      h3{
        font-size: .8rem;
        color: #222;
        margin: .75rem 0;
      }
    }
    .m-body{
      width: 16.7rem;
      max-height: 22.5rem;
      margin: 0 auto;
      overflow-y: auto;
      overflow-x: hidden;
      p{
        line-height: 1.5;
        font-size: .7rem;
        color: #333;
        margin-bottom: .6rem;
      }
    }
  }
  .error-msg{
    font-size: .65rem;
    color: #FF4743;
  }
  .footer{
    .btn-group{
      justify-content: center;
      /*
      width: 16.2rem;
      .jump-btn{
        width: 3rem;
        font-size: .8rem;
        color: #47B6C7;
        text-align: right;
      }
      */
    }
  }
  .select-cont{
    width: 16.7rem;
    height: 2rem;
    border: 1PX solid #ddd;
    border-radius: .5rem;
    padding: 0 15px;
    box-sizing: border-box;
    margin: 0 auto .5rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &-name{
      font-size: .8rem;
      color: #222;
    }
    &-empty{
      color: #c0c4cc;
    }
  }

  .bank-modal{
    width: 100%;
    .m-header{
      width: 90%;
      margin: 0 auto;
      line-height: 2.4rem;
      font-size: 0.8rem;
      color: #222;
      font-weight: bold;
    }
    .m-body{
      .input{
        width: 90%;
        margin: 0 5% .5rem;
      }
      .infinite-list{
        height: 25rem;
        overflow: auto;
        padding-bottom: 1rem;
        .infinite-list-item{
          line-height: 2.2rem;
          font-size: .7rem;
          color: #222;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 .5rem;
          .bank-name{
            font-size: .7rem;
            color: #222;
          }
          .icon{
            font-size: 1rem;
            color: #c0c4cc;
          }
          .icon-agree{
            color: #47B6C7;
          }
        }

      }
    }

  }
}
@media screen and (min-width:750px){
  .wrapper{
    height: auto;
  }
  .container{
    height: 70vh;
  }
  .section{
    width: 334px;
    margin: 0 auto 28px;
    h5{
      margin-bottom: 8px;
      font-size: 14px;
      color: #666;
      font-weight: 400;
      display: flex;
      align-items: center;
      .icon-doubt{
        width: 16px;
        margin-left: 4px;
        cursor: pointer;
      }
    }
    .select-card{
      width: 100%;
      margin: 10px 0;
      /deep/ .el-input__inner{
        border-radius: 10px;
        font-size: 14px;
        color: #222;
      }
    }
    .upload-group{
      @include flex(space-between);
      /deep/ .el-input__inner, /deep/ .el-textarea__inner{
        border-radius: 10px;
        border: 1px solid #ddd;
        font-size: 16px;
        color: #222;
      }
      /deep/ .el-input__inner::-webkit-input-placeholder, /deep/ .el-textarea__inner::-webkit-input-placeholder{
        font-size: 16px;
      }
      /deep/ .el-input__inner{
        height: 48px;
      }


      /deep/ .van-uploader__input-wrapper{
        width: 150px;
        height: 150px;
        @include flex();
        flex-direction: column;
      }
      .item{
        width: 150px;
        height: 150px;
        background: #F5F5F7;
        border-radius: 16px;
        text-align: center;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        .icon-add{
          font-size: 24px;
          color: $base-color;
        }
        .txt{
          display: inline-block;
          font-size: 14px;
          color: #999;
          margin-top: 6px;
        }
      }
      .img-list{
        img{
          width: 150px;
          height: 150px;
          border-radius: 16px;
        }
        .img-box{
          position: relative;
          .iconfont{
            font-size: 28px;
            color: #222;
            position: absolute;
            right: 2px;
            top: 2px;
            z-index: 2;
          }
        }
      }
    }
    .input-group{
      margin-top: 10px;
      .input-row{
        margin-bottom: 10px;
      }
      .row{
        height: 40px;
        @include flex-align();
        margin-bottom: 5px;
        .label-name{
          width: 88px;
          height: 40px;
          line-height: 40px;
          display: inline-block;
          margin-right: 5px;
          font-size: 15px;
          color: #222;
          text-align: left;
        }
      }
      /deep/ input, .validity-box{
        height: 40px;
        // margin-bottom: 5px;
        border-radius: 10px;
        // border-radius: 10px 0 0 10px;
        // border: 1px solid #ddd;
        font-size: 16px;
        color: #222;
        span{
          // width: 100%;
          height: 40px;
          line-height: 40px;
          padding: 0 .75rem;
          display: inline-block;
          font-size: 16px;
        }
        .date-time{
          width: 320px;
          color: #222;
        }
        .date-placeholder{
          width:100%;
          display: inline-block;
          color: #ccc;
        }
      }
      .col-valid-disable{
        width:250px;background:#f5f5f5;border-radius:10px 0 0 10px;
      }
      /deep/ .el-input__inner::-webkit-input-placeholder {
        font-size: 16px;
        color: #ccc;
        font-weight: 400;
      }
      .validity-box, .pc-validity-box{
        width: 100%;
      }
      /deep/ .is-disabled{
      .el-input__inner{
          border-radius: 10px 0 0 10px !important;
        }
      }
    }
  }
  .types-section{
    margin-top: 25px;
    .tag-list{
      width: 334px;
      display: flex;
      flex-wrap: wrap;
      &-item{
        width: 102px;
        height: 44px;
        background: #fff;
        border-radius: 10px;
        border: 1px solid #CFE1EA;
        font-size: 16px;
        color: #222;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 10px 10px 0;
        cursor: pointer;
        &:nth-child(3n+3){
          margin-right: 0;
        };
        &-active{
          background: $base-color;
          border: 1px solid $base-color;
          color: #fff;
        }
      }
    }
  }
  .validity-box, .pc-validity-box{
    border: .05rem solid #DCDFE6;
  }
  .pc-validity-box{
    border-radius:10px;
    /deep/ .el-input__inner{
      border: 0;
    }
  }
  .validity-box, .pc-validity-box{
    position: relative;
    /deep/ .el-checkbox{
      width: 80px;
      height: 40px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
      color: #47B6C7;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background: #47B6C7;
      border-color: #47B6C7;
    }
  }
  .pc-validity-box{
    height: 40px;
    /deep/ .el-checkbox__input, /deep/ .el-checkbox__inner{
      width: 16px;
      height: 16px;
    }
    /deep/ .el-checkbox__inner::after{
      height: 12px;
      left: 5px;
    }
    /deep/ .el-checkbox__label{
      line-height: 1;
      font-size: 14px;
    }
    /deep/ .el-input__inner{
      margin-bottom: 0;
    }
  }
  .radio-group-section{
    width: 334px;
    height: 60px;
    margin-bottom: 13px;
    /deep/ .van-radio__icon{
      font-size: 0.6rem !important;
    }
    .radio-group{
      height: 60px;
      .van-radio-group{
        height: 60px;
        .van-radio{
          font-size: 16px;
          color: #222;
          &:first-child{
            margin-right: 36px;
          }
        }
      }
    }
  }
  .bank-select-box{
    width: 333px;
    height: 40px;
    /deep/ .el-input{
      height: 40px;
    }
    /deep/  .el-input__inner{
      height: 40px;
      border-radius: 10px;
      border: 1px solid #DDDDDD;
      font-size: 16px;
      color: #222;
    }
    /deep/ .el-input__inner::-webkit-input-placeholder {
      font-size: 16px;
      color: #ccc;
      font-weight: 400;
    }
  }
  .supplement-section{
    .upload-item{
      /deep/ .img-box{
        margin-bottom: 20px;
      }
    }
  }
  .agreement-section{
    padding: 12px 16px;
    background: #F5F5F7;
    border-radius: 16px;
    box-sizing: border-box;
    @include flex();
    .iconfont{
      font-size: 20px;
      cursor: pointer;
    }
    .icon-a-noSelected{
      color: #ccc;
    }
    .icon-agree{
      color: $base-color;
    }
    .agreement-info{
      line-height: 1.5;
      margin-left: 12px;
      font-size: 14px;
      color: #0A1629;
      cursor: pointer;
      a{
        font-size: 14px;
        color: #0A1629;
      }
      .licence{
        font-size: 14px;
        color: $base-color;
      }
    }
  }

  .agreement-modal{
    width: 334px;
    margin: 0 auto;
    padding-top: 1px;
    padding-bottom: 15px;
    .m-header{
      width: 334px;
      margin: 0 auto;
      h3{
        font-size: 16px;
        color: #222;
        margin: 15px 0;
      }
    }
    .m-body{
      width: 334px;
      max-height: 450px;
      margin: 0 auto;
      overflow-y: auto;
      overflow-x: hidden;
      p{
        line-height: 1.5;
        font-size: 14px;
        color: #333;
        margin-bottom: 12px;
      }
    }
  }
  .error-msg{
    font-size: 13px;
    color: #FF4743;
  }
  .footer-bar{
    height: 100px;
    // display: block;
  }
  .footer{
    position: inherit;
    bottom: 0;
    padding: 20px 0 30px;
    .btn-group{
      justify-content: center;
      /*
      width: 324px;
      .jump-btn{
        width: 60px;
        font-size: 16px;
        color: #47B6C7;
        text-align: right;
      }
      */
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/distribution/baseinfo-auth.vue